import { render } from "./InnovationList.vue?vue&type=template&id=1744e826&scoped=true"
import script from "./InnovationList.vue?vue&type=script&lang=js"
export * from "./InnovationList.vue?vue&type=script&lang=js"

import "./InnovationList.vue?vue&type=style&index=0&id=1744e826&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1744e826"]])

export default __exports__